import React, { useEffect, useState } from "react";
import { Builder } from "@builder.io/react";
import { useSelector } from "react-redux";
import { selectProducts } from "../../../../../store/products";
import { selectSelectedCurrency } from "../../../../../store/user";
import AqiqahTabContent from "../../../../../pages/sadaqah-jariyah/components/aqiqahTabContent";
const DonationPriceListWidget = ({title, description, image, maxWidth="sm:max-w-[320px]"}) => {

  const products = useSelector(state => selectProducts(state));
  const [sheepGoatSacrificeProducts, setSheepGoatSacrificeProducts] = useState([0, 0, 0, 0, 0, 0]);
  const [isLoaded, setIsLoaded] = useState(false);
  const selectedCurrency = useSelector(selectSelectedCurrency);

  const tabButtonsProducts = [
    {
      title,
      description,
      items: [
        {
          title,
          description,
          products: sheepGoatSacrificeProducts,
          image,
        },
      ],
    },
  ];

  const getAllProducts = () => {
    setIsLoaded(true);
    let sheepGoatSacrificeProductsList = [];
    products.forEach(item => {
      item.sub_categories.forEach(inner_item => {
        inner_item.products.forEach(inner_item_product => {
          if (inner_item_product.creator === 'SAC-DEL-SSS-2023-01-001') {
            sheepGoatSacrificeProductsList[0] = inner_item_product;
          } else if (inner_item_product.creator === 'SAC-DEL-WSS-2023-01-003') {
            sheepGoatSacrificeProductsList[1] = inner_item_product;
          } else if (inner_item_product.creator === 'SAC-DEL-ASS-2023-01-002') {
            sheepGoatSacrificeProductsList[2] = inner_item_product;
          } else if (inner_item_product.creator === 'SAC-DEL-NSS-2023-01-004') {
            sheepGoatSacrificeProductsList[3] = inner_item_product;
          } else if (inner_item_product.creator === 'SAC-DEL-SGB-2023-01-007') {
            sheepGoatSacrificeProductsList[4] = inner_item_product;
          } else if (inner_item_product.creator === 'SAC-DEL-SSY-2023-01-006') {
            sheepGoatSacrificeProductsList[5] = inner_item_product;
          }
        });
      });
    });
    sheepGoatSacrificeProductsList = sheepGoatSacrificeProductsList.filter(n => n);
    setSheepGoatSacrificeProducts(sheepGoatSacrificeProductsList);
  };

  useEffect(() => {
    products && Object.keys(products).length && !isLoaded && getAllProducts();
  }, [products]);



  return (
    <div className="bg-[#eaf7ff]">
      <div className={`md:container w-full mx-auto px-4 md:px-0 py-2 mb-2 md:py-4 md:mb-2 space-y-3 md:space-y-7`} >
        {tabButtonsProducts.map(
          (tab, index) =>
            <React.Fragment key={`description_${index}`}>
              <AqiqahTabContent
                items={tab.items}
                showArrows={true}
                currency={selectedCurrency}
                showMultiProductsOnRow={false}
                hasCustomPrice={tab.hasCustomPrice}
                title={tab.title}
                maxWidth={maxWidth}
              />
            </React.Fragment>
        )}
      </div>
    </div>
  );
}

Builder.registerComponent(DonationPriceListWidget, {
  name: "DonationPriceListWidget",
  inputs: [
    {
      name: "title",
      type: "string",
      defaultValue: "Sheep/Goat Sacrifice",
      helperText: "Title for the section"
    },
    {
      name: "description",
      type: "string",
      defaultValue: "Sadaqah is a voluntary act of charity in Islam, Providing meat to those in need is a noble cause. Support our Sadaqah sheep sacrifice program",
    },
    {
      name: "image",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "svg"],
      helperText: "Image for the section",
    },
    {
      name: "maxWidth",
      type: "string",
      defaultValue: "sm:max-w-[320px]",
      helperText: "Max width for the section",
    },
  ],
});

export default DonationPriceListWidget;
